// node modules
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Select from 'react-select';
import Jmoment from 'moment-jalaali';
// actions
import { postCheckoutReport, getCheckoutCafe } from '../../../redux/checkouts/reports/actions';
// Components
import Spin from '../../../components/loading';
import DatePicker from '../../../components/FormElements/DatePicker/DatePicker';
// Enums
import ENUMS from '../../../enums';

const dataObject = {
  payType: '',
  paidAt: '',
  payerName: '',
  sourceBankName: '',
  payTypeValue: '',
  destinationBankName: '',
  cardNumber: '',
  accountNumber: '',
};

function ReservesCheckoutReportModal(props) {
  const dispatch = useDispatch();
  const state = useSelector(state => state.checkoutReportsReducer);
  const [data, setData] = useState(dataObject);
  const [error, setError] = useState({ dataObject });

  const closeModal = () => {
    props.setShowReserveModal('');
  };

  const handleOnPaidAt = (value) => {
    setData({ ...data, paidAt: Jmoment(value).format('jYYYY/jMM/jDD') });
    setError({ ...error, paidAt: '' });
  };
  const handleOnPayType = (obj) => {
    setData({ ...data, payType: obj });
    setError({ ...error, payType: '', cardNumber: '' });
    setError({ ...error, payType: '', accountNumber: '' });
  };
  const handleOnChangeValue = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setData({ ...data, [name]: value });
    setError({ ...error, [name]: '' });
  };
  const submitForm = () => {
    let updateData;


    if (data.payType.value === 'CARD') {
      updateData = {
        ...data,
        payType: data.payType.value,
        payTypeValue: data.cardNumber,
      };
      delete updateData.accountNumber;
      delete updateData.cardNumber;
    }
    if (data.payType.value === 'CHECK') {
      updateData = {
        ...data,
        payType: data.payType.value,
      };
      delete updateData.accountNumber;
      delete updateData.cardNumber;
    }
    if (data.payType.value === 'CASH_TRANSFER') {
      updateData = {
        ...data,
        payType: data.payType.value,
        payTypeValue: data.accountNumber
      };
      delete updateData.accountNumber;
      delete updateData.cardNumber;
    }
    if (Object.values(updateData).some(x => x == null || x === '')) {
      const emptyFields = Object.keys(data).reduce((newObj, key) => {
        const value = data[key];
        if (value === null || value === '') {
          newObj[key] = locales('messages.fieldValueIsRequired', { fieldName: locales(`fields.checkout.${key}`) });
        }
        return newObj;
      }, {});
      let updateError;
      if (data.payType.value !== 'CHECK') {
        updateError = {
          ...error,
          payTypeValue: '',
        };
      } else {
        updateError = { ...error };
      }
      setError({ ...updateError, ...emptyFields });
    }
    else {
      dispatch(postCheckoutReport({ ...updateData, cafeId: props.selectedRecordId }));
    }
  };

  useEffect(() => {
    if (state.checkoutSpecificRecord.checkout) {
      closeModal();
      props.filterAndSort();
    }
  }, [state.checkoutSpecificRecord.checkout]);


  useEffect(() => {
    if (state.checkoutCafe.bankName && state.checkoutCafe.accountNumber && state.checkoutCafe.cardNumber) {
      setData({
        ...dataObject,
        destinationBankName: state.checkoutCafe.bankName,
        accountNumber: state.checkoutCafe.accountNumber,
        cardNumber: state.checkoutCafe.cardNumber,
      });
    }
  }, [state.checkoutCafe]);


  useEffect(() => {
    dispatch(getCheckoutCafe(props.selectedRecordId));
  }, []);

  return (
    <Modal isOpen={props.showReserveModal === 'checkout-modal'} size='lg'>
      <ModalHeader>
          <span className='modal-title'>
            {locales('titles.checkoutWithCafe') + props.selectedCafeName}
          </span>
        <span
          title={locales('labels.close.modal')}
          className='modal-close'
          onClick={closeModal}
        >
            close
          </span>
      </ModalHeader>
      <ModalBody>
        <Spin
          spinning={state.postCheckoutLoading}
        >
          {
            state.postCheckoutError ? (
              <div className='alert alert-danger'>
                {locales('messages.server.error')}
              </div>
            ) : (
              <div className='container'>
                {state.postCheckoutFailed &&
                <div className='alert alert-danger'>{state.postCheckoutMessage}</div>}
              </div>
            )}
        </Spin>
        <form>
          <div className='col-12 d-flex justify-content-around p-0 align-items-center my-4'>
            <div className='col-4 p-0 required'>
              <label className='rsee-form-label'>{locales('fields.checkout.paidAt')}</label>
              <DatePicker
                marge={true}
                name='paidAt'
                id='paidAt'
                className={`${!!error.paidAt ? 'is-invalid' : ''} form-control ml-4 required`}
                placeholder={locales('fields.checkout.paidAt')}
                onChange={handleOnPaidAt}
                value={data.paidAt}
              />
              {!!error.paidAt && <div className='text-danger text-center'>{error.paidAt}</div>}
            </div>
            <div className='col-4 p-0 required'>
              <label className='rsee-form-label'>
                {locales('fields.checkout.sourceBankName')}
              </label>
              <input
                className={`${
                  !!error.sourceBankName ? 'is-invalid' : ''
                } form-control ml-4 required`}
                name='sourceBankName'
                value={data.sourceBankName}
                placeholder={locales('fields.checkout.sourceBankName')}
                onChange={handleOnChangeValue}
                maxLength={ENUMS.MAX_LENGTH.bankName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.20')}</small>
              {!!error.sourceBankName && (
                <div className='text-danger text-center'>{error.sourceBankName}</div>
              )}
            </div>

          </div>
          <div className='col-12 d-flex justify-content-around p-0 align-items-center my-4'>

            <div className='col-4 p-0 required'>
              <label className='rsee-form-label'>{locales('fields.checkout.payerName')}</label>
              <input
                className={`${!!error.payerName ? 'is-invalid' : ''} form-control ml-4 required`}
                name='payerName'
                value={data.payerName}
                placeholder={locales('fields.checkout.payerName')}
                onChange={handleOnChangeValue}
                maxLength={ENUMS.MAX_LENGTH.fullName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
              {!!error.payerName && (
                <div className='text-danger text-center'>{error.payerName}</div>
              )}
            </div>
            <div className='col-4 p-0 required'>
              <label className='rsee-form-label'>
                {locales('fields.checkout.destinationBankName')}
              </label>
              <input
                className={`${
                  !!error.destinationBankName ? 'is-invalid' : ''
                } form-control ml-4 required`}
                name='destinationBankName'
                value={state.checkoutCafe.bankName || data.destinationBankName}
                onChange={handleOnChangeValue}
                disabled={true}
              />
            </div>
          </div>

          <div className='col-12 d-flex justify-content-around p-0 align-items-center my-4'>
            <div className='col-4 p-0 required'>
              <label className='rsee-form-label'>{locales('fields.checkout.payType')}</label>
              <Select
                id='payType'
                name='payType'
                className={`rc-dropdown ${!!error.payType ? 'is-invalid' : ''} w-100 required`}
                value={data.payType}
                options={ENUMS.PAY_TYPES.list.map(x => ({
                  label: x.title,
                  value: x.value,
                }))}
                placeholder={locales('fields.checkout.payType')}
                isMulti={false}
                onChange={handleOnPayType}
              />
              {!!error.payType && <div className='text-danger text-center'>{error.payType}</div>}
            </div>
            {
              data.payType.value === 'CARD' &&
              <div className='col-4 p-0 required'>
                <label className='rsee-form-label'>{locales('fields.card.number')}</label>
                <input
                  className={`${
                    !!error.cardNumber ? 'is-invalid' : ''
                  } form-control ml-4 required`}
                  name='cardNumber'
                  value={state.checkoutCafe.cardNumber || data.cardNumber}
                  onChange={handleOnChangeValue}
                  disabled={true}
                />
              </div>
            }
            {
              data.payType.value === 'CASH_TRANSFER' &&
              <div className='col-4 p-0 required'>
                <label className='rsee-form-label'>{locales('fields.account.number')}</label>
                <input
                  className={`${
                    !!error.accountNumber ? 'is-invalid' : ''
                  } form-control ml-4 required`}
                  name='accountNumber'
                  value={state.checkoutCafe.accountNumber || data.accountNumber}
                  onChange={handleOnChangeValue}
                  disabled={true}
                />
              </div>
            }
            {
              data.payType.value === 'CHECK' &&
              <div className='col-4 p-0 required'>
                <label className='rsee-form-label'>{locales('fields.check.number')}</label>
                <input
                  className={`${
                    !!error.payTypeValue ? 'is-invalid' : ''
                  } form-control ml-4 required`}
                  name='payTypeValue'
                  value={data.payTypeValue}
                  placeholder={locales('fields.check.number')}
                  onChange={handleOnChangeValue}
                  maxLength={ENUMS.MAX_LENGTH.bankName}
                />
                <small style={{ color: '#ccc' }}>{locales('maxLength.30')}</small>
                {!!error.payTypeValue && (
                  <div className='text-danger text-center'>{error.payTypeValue}</div>
                )}
              </div>
            }
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <button
          type='submit'
          className='btn btn-success'
          onClick={submitForm}
        >
          <i className='fa fa-save'></i>ذخیره
        </button>
        <button
          className='btn btn-light mx-1'
          onClick={closeModal}
          disabled={state.loading}
        >
          <i className='fa fa-reply'></i>
          {locales('labels.close.modal')}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default ReservesCheckoutReportModal;
